<template>
  <section
    style="display: flex; flex-direction: row; align-items: center"
    @click="openGroupPreview($event)"
  >
    <img class="leftSidePic" :src="group.profileImage" />
    <div style="padding-left: 15px">
      <p class="notifTitle">{{ group.groupName }}</p>
      <p class="notifText">From {{ group.name }}</p>
    </div>
    <div class="selectionRow">
      <button @click="rejectRequest" class="requestButton reject"></button>
      <button @click="acceptRequest" class="requestButton accept"></button>
    </div>
  </section>
</template>

<script>
import db from "@/db";
import firebase from "@/firebase";
import { mapState, mapActions } from "vuex";

export default {
  props: ["group", "requests"],

  components: {},

  data: () => ({
    type: "",
  }),
  mounted() {
    if (this.group.type === "course") {
      this.type = "courses";
    } else if (this.group.type === "faculty") {
      this.type = "faculties";
    } else {
      this.type = "groups";
    }
  },

  computed: {
    ...mapState("user", ["user"]),
  },

  methods: {
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("messageBoard", ["subscribeToTopic"]),
    openGroupPreview(event) {
      if (
        event.target.className !== "requestButton reject" &&
        event.target.className !== "requestButton accept"
      ) {
        db.collection(this.type)
          .doc(this.group.group_id)
          .get()
          .then((doc) => {
            var previewCourse = doc.data();
            previewCourse.type = this.type;
            previewCourse.id = this.group.group_id;
            this.$store.commit("messageBoard/setGroupPreview", previewCourse);
            this.$store.commit("messageBoard/setSearchGroup", true);
          });
      }
    },
    async acceptRequest() {
      var groupPreview;
      await db
        .collection(this.type)
        .doc(this.group.group_id)
        .get()
        .then((doc) => {
          groupPreview = doc.data();
          groupPreview.type = this.type;
          groupPreview.id = this.group.group_id;
        });
      let data = {
        name: this.user.firstName + " " + this.user.lastName,
        profileImage: this.user.profileImage,
        user_id: this.user.id,
      };
      groupPreview.recentPosts = !groupPreview.recentPosts
        ? []
        : groupPreview.recentPosts;

      if (groupPreview.type == "courses") {
        this.user.courses.push({
          name: groupPreview.name,
          id: groupPreview.id,
          lastVisited: Date.now(),
          notificationsEnabled: true,
          subject: groupPreview.subject,
          recentPosts: groupPreview.recentPosts,
          users: groupPreview.users,
          hasSeenLastPost: groupPreview.hasSeenLastPost,
          type: "courses",
        });
        this.user.course_ids.push(groupPreview.id);
      } else if (groupPreview.type == "faculties") {
        this.user.faculties.push({
          name: groupPreview.name,
          id: groupPreview.id,
          lastVisited: Date.now(),
          notificationsEnabled: true,
          recentPosts: groupPreview.recentPosts,
          users: groupPreview.users,
          hasSeenLastPost: groupPreview.hasSeenLastPost,
          type: "faculties",
        });
        this.user.faculty_ids.push(groupPreview.id);
      } else {
        this.user.groups.push({
          name: groupPreview.name,
          id: groupPreview.id,
          lastVisited: Date.now(),
          notificationsEnabled: true,
          recentPosts: groupPreview.recentPosts,
          users: groupPreview.users,
          hasSeenLastPost: groupPreview.hasSeenLastPost,
          type: "groups",
        });
        this.user.group_ids.push(groupPreview.id);
      }
      db.collection(groupPreview.type)
        .doc(groupPreview.id)
        .update({
          users: firebase.firestore.FieldValue.arrayUnion(data),
          userCount: firebase.firestore.FieldValue.increment(1),
        });

      this.$store.commit("messageBoard/setGroupId", groupPreview.id);
      this.$store.commit("messageBoard/setGroupName", groupPreview.name);
      this.$store.commit("messageBoard/setGroupType", groupPreview.type);
      this.$store.commit("messageBoard/setCurGroup", groupPreview);
      this.$store.commit("user/setUser", this.user);
      this.updateUserGroups();
      this.subscribeToTopic({ groupId: groupPreview.id, user: this.user });

      var joinedContent =
        this.user.firstName +
        " " +
        this.user.lastName +
        " accepted " +
        this.group.name +
        "'s invite";

      this.addUserJoinedGroupPost(joinedContent, groupPreview);

      this.$router.push({
        name: "MessageBoard",
        params: {
          name: groupPreview.name,
          id: groupPreview.id,
          type: groupPreview.type,
        },
      });
      this.rejectRequest();
      this.$store.commit("messageBoard/setGroupPreview", undefined);
      this.$store.commit("messageBoard/setSearchGroup", false);
    },
    addUserJoinedGroupPost(content, group) {
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set({
          content: content,
          chat_id: group.id,
          created_at: Date.now(),
        });
      if (!group.recentPosts) {
        group.recentPosts = [];
      }
      group.recentPosts.push({
        content: content,
        created_at: Date.now(),
        id: id,
      });
      while (group.recentPosts.length > 25) {
        group.recentPosts.splice(0, 1);
      }

      db.collection(group.type)
        .doc(group.id)
        .update({
          recentPosts: group.recentPosts,
        });
    },
    rejectRequest() {
      db.collection("users")
        .doc(this.user.id)
        .update({
          groupInvites: firebase.firestore.FieldValue.arrayRemove(this.group),
        });
      let index = this.user.groupInvites.findIndex(
        (invite) => invite.group_id === this.group.group_id
      );
      this.user.groupInvites.splice(index, 1);
      this.$store.commit("user/setUser", this.user);
    },
  },
};
</script>

<style scoped>
.requestButton {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin: 3px;
  cursor: pointer;
  border: none;
  background-color: white;
}

.requestButton:hover {
  background-color: #d0d0d0;
}
.notifTitle {
  color: black;
  font-weight: bold;
}
.notifText {
  font-size: 13px;
}
.selectionRow {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: 0;
}
.reject {
  background-image: url("../../assets/linkDeny.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
.accept {
  background-image: url("../../assets/linkAccept.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
</style>
